import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ExportReports = ({ tournamentId, onExport }) => {
  const [selectedReport, setSelectedReport] = useState('');
  const [isExporting, setIsExporting] = useState(false);

  const reportOptions = [
    { 
      value: 'results-summary', 
      label: 'Results Summary',
      description: 'Complete match results with scores and winners'
    },
    { 
      value: 'points-distribution', 
      label: 'Points Distribution',
      description: 'User-wise points breakdown by category'
    },
    { 
      value: 'leaderboard-snapshot', 
      label: 'Leaderboard Snapshot',
      description: 'Current tournament standings'
    },
    { 
      value: 'prediction-accuracy', 
      label: 'Prediction Accuracy',
      description: 'User prediction success rates'
    }
  ];

  const handleExport = async () => {
    if (!selectedReport) return;
    
    setIsExporting(true);
    await onExport(tournamentId, selectedReport);
    setIsExporting(false);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Download" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Export Reports</h3>
          <p className="text-sm text-muted-foreground">
            Download result summaries and analytics
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <Select
          label="Report Type"
          description="Choose the report you want to export"
          options={reportOptions}
          value={selectedReport}
          onChange={setSelectedReport}
          placeholder="Select report type..."
        />

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            onClick={() => setSelectedReport('')}
            disabled={!selectedReport}
            className="flex-1 sm:flex-initial"
          >
            Clear
          </Button>
          <Button
            variant="default"
            onClick={handleExport}
            loading={isExporting}
            disabled={!selectedReport}
            iconName="Download"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
          >
            Export as CSV
          </Button>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={18} className="text-primary flex-shrink-0 mt-0.5" />
            <p className="text-xs text-muted-foreground">
              Reports include data up to the current date and time. Exported files are in CSV format compatible with Excel and Google Sheets.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportReports;